export default __webpack_public_path__ + "static/media/jap-ecommerceImg_2.a3cdb32e.png";